<template>
  <div class="pagination">
    <a href="#" class="pagination__item page-active"><span class="pagination__item-number">1</span></a>
    <a href="#" class="pagination__item"><span class="pagination__item-number">2</span></a>
    <a href="#" class="pagination__item"><span class="pagination__item-number">3</span></a>
    <a href="#" class="pagination__item"><span class="pagination__item-number">4</span></a>
  </div>
</template>

<script>
export default {
  name: 'paginationNew'
}
</script>

<style lang="scss">
  @import "../assets/scss/components/pagination-new";
</style>
